// Copyright (c) Bentley Systems
import {
  Svg401,
  Svg403,
  Svg404,
  Svg500,
  SvgError,
} from "@itwin/itwinui-illustrations-react";
import { Button, NonIdealState } from "@itwin/itwinui-react";
import { useAppDispatch, useAppSelector } from "../app/hooks";
import { useEffect, useMemo } from "react";
import { ErrorState, selectIsError, setIsError } from "../app/is-error-slice";
import { getQueryParam } from "../Helpers/helper-functions";
import { useNavigate } from "react-router-dom";

const ErrorPage = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const isErrorState = useAppSelector(selectIsError);
  const isBackToEntryScreenQueryParameter = getQueryParam("backToEntryScreen");

  const nonIdealStateElement = useMemo(() => {
    if (isErrorState.errorState !== ErrorState.NoError) {
      const actions = isBackToEntryScreenQueryParameter && (
        <>
          <Button
            onClick={() => {
              const url = `/entry${  window.location.search}`;
              void navigate(url);
            }}
            styleType={"high-visibility"}
          >
            Back
          </Button>
        </>
      );

      const activityId =
        isErrorState.activityId && `(ActivityId="${isErrorState.activityId}")`;

      switch (isErrorState.errorState) {
        case ErrorState.NotFound: {
          return (
            <NonIdealState
              description={
                <>
                  We can not find the entity that you are looking for or it does
                  not exist.
                  <br />
                  Contact our support team for assistance.
                  <br />
                  <br />
                  {activityId}
                </>
              }
              heading="Not found"
              svg={<Svg404 />}
              actions={actions}
            />
          );
        }
        case ErrorState.Forbidden: {
          return (
            <NonIdealState
              svg={<Svg403 />}
              heading="Forbidden"
              description={
                <>
                  You do not have permission to access this enity.
                  <br />
                  Unable to fulfill request.
                  <br />
                  Contact our support team for assistance.
                  <br />
                  <br />
                  {activityId}
                </>
              }
              actions={actions}
            />
          );
        }
        case ErrorState.InternalServerError: {
          return (
            <NonIdealState
              svg={<Svg500 />}
              heading="Internal server error"
              description={
                <>
                  Please try again.
                  <br />
                  If the issue persists, contact our support team for
                  assistance.
                  <br />
                  <br />
                  {activityId}
                </>
              }
              actions={actions}
            />
          );
        }
        case ErrorState.Unauthorized: {
          return (
            <NonIdealState
              heading="Unauthorized"
              description={
                <>
                  You do not have permission to access this enity.
                  <br />
                  Unable to fulfill request.
                  <br />
                  Contact our support team for assistance.
                  <br />
                  <br />
                  {activityId}
                </>
              }
              svg={<Svg401 />}
              actions={actions}
            />
          );
        }
        default: {
          return (
            <NonIdealState
              heading="Something went wrong"
              description={
                <>
                  Please try again.
                  <br />
                  If the issue persists, contact our support team for
                  assistance.
                  <br />
                  <br />
                  {activityId}
                </>
              }
              svg={<SvgError />}
              actions={actions}
            />
          );
        }
      }
    }
  }, [isErrorState.errorState]);

  useEffect(() => {
    return () => {
      // your clearup code. =>> This block will work as componentWillUnmount
      dispatch(
        setIsError({ errorState: ErrorState.NoError, activityId: undefined }),
      );
    };
  }, [dispatch]);
  return <div>{nonIdealStateElement}</div>;
};

export default ErrorPage;
